import { blog, blogArticle } from "~/web/site/blog";
import { cinema } from "~/web/site/cinema";
import { cookieConsent } from "~/web/site/cookie-consent";
import { guestForm } from "~/web/site/form";
import { hero, mobileMenu } from "~/web/site/hero";
import { loginPage } from "~/web/site/login";
import { startRedditPixel, stopRedditPixel } from "~/web/site/reddit-pixel";
import { startAnalytics, track } from "~/web/src/analytics";
import { keepFirstTouch } from "~/web/src/first-touch";
import { startGoogleAnalytics } from "~/web/src/google-analytics";

// The static site's one JS island (featurette #49), bundled by esbuild to
// /static/site.js and loaded as a module script, so it runs after the page
// has rendered and nothing on the page waits for it. Its jobs: the tab's first
// touch (web/src/first-touch.ts), the cookie banner and, once that allows them,
// PostHog (the anonymous person born here is
// the one the SPA identifies after sign-in — same origin, same cookie; refused
// = no person, nothing to merge), Google Analytics and the Reddit Pixel, the clicks that lead away before any server
// sees them, the home page's motion + sample dialog, the landing form
// (web/site/form.ts), the after-credits film, the blog's filter and cover, and
// the login page (web/site/login.ts). Every part guards on its markup.

void keepFirstTouch();

// a blocked or failing SDK is not the page's problem
cookieConsent({
  analytics: () => {
    try {
      startAnalytics();
    } catch {}
    try {
      startGoogleAnalytics();
    } catch {}
  },
  advertising: () => {
    try {
      startRedditPixel();
    } catch {}
  },
  noAdvertising: stopRedditPixel,
});

// Links marked data-track="<event>" capture instantly — the navigation is next.
document.addEventListener("click", (e) => {
  const link = (e.target as Element | null)?.closest<HTMLElement>("a[data-track]");
  const name = link?.dataset.track;
  if (name) track(name, {}, { instant: true });
});

mobileMenu();
hero();
const form = document.querySelector<HTMLFormElement>("form[data-guest-form]");
if (form) guestForm(form);
cinema();
blog();
blogArticle();

const login = document.querySelector<HTMLElement>('main[data-page="login"]');
if (login) loginPage(login);
